enum DocumentEvent {
    // SlideStockの資料ダウンロード
    GetSlideStockDocumentStarted = "[DocumentEvent] GetSlideStockDocumentStarted",
    GetSlideStockDocumentCompleted = "[DocumentEvent] GetSlideStockDocumentCompleted",

    // 動画の資料ダウンロード
    GetVideoDocumentStarted = "[DocumentEvent] GetVideoDocumentStarted",
    GetVideoDocumentCompleted = "[DocumentEvent] GetVideoDocumentCompleted",

    // 資料ダウンロードリンクをリセットする。
    ResetDocumentUrl = "[DocumentEvent] ResetDocumentUrl",
}
export default DocumentEvent;
